(function () {
  const getScrollOffset = () => {
    const headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--header-height")
    );
    return (Number.isFinite(headerHeight) ? headerHeight : 0) + 16;
  };

  const scrollToElement = (element) => {
    if (!element) return;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const top = window.scrollY + element.getBoundingClientRect().top - getScrollOffset();
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReduced ? "auto" : "smooth",
    });
  };

  const openAccordion = ($toggle) => {
    if ($toggle.hasClass("active")) return;
    $toggle.addClass("active");
    $toggle
      .closest(".about__accordion-item")
      .find(".about__accordion-description")
      .first()
      .stop()
      .slideDown(300);
  };

  const openAccordionFromHash = () => {
    const hash = decodeURIComponent(window.location.hash.slice(1));
    if (!hash) return;

    const target = document.getElementById(hash);
    if (!target || !target.classList.contains("about")) return;

    const $toggle = $(target).find(".about__accordion-toggle").first();
    if ($toggle.length) openAccordion($toggle);

    requestAnimationFrame(() => {
      scrollToElement(target);
    });
  };

  const initProductAccordion = () => {
		$(".about__accordion-toggle").off("click.productAccordion").on("click.productAccordion", function () {
      const $toggle = $(this);
      const $description = $toggle
        .closest(".about__accordion-item")
        .find(".about__accordion-description")
        .first();

			if (!$toggle.hasClass("active")) {
				$toggle.addClass("active");
				$description.stop().slideDown(300);
			} else {
				$toggle.removeClass("active");
				$description.stop().slideUp(300);
			}
		});
  };

  const initCustomCursor = () => {
    // Create custom cursor element
    let cursor = document.querySelector('.product-zoom-cursor');
    if (!cursor) {
      cursor = document.createElement('div');
      cursor.className = 'product-zoom-cursor';
      document.body.appendChild(cursor);
    }

    // Get all zoom trigger elements
    const zoomTriggers = document.querySelectorAll('.product__media-toggle, .product-media-modal__content');

    // Mouse move handler
    const moveCursor = (e) => {
      cursor.style.left = e.clientX - 24 + 'px'; // Center the 48px cursor
      cursor.style.top = e.clientY - 24 + 'px';
    };

    // Add event listeners to zoom triggers
    zoomTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => {
        cursor.classList.add('active');
        document.addEventListener('mousemove', moveCursor);
      });

      trigger.addEventListener('mouseleave', () => {
        cursor.classList.remove('active');
        document.removeEventListener('mousemove', moveCursor);
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;
    
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initCustomCursor();
    openAccordionFromHash();
  });

  initProductAccordion();
  initZoomImage();
  initCustomCursor();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openAccordionFromHash);
  } else {
    openAccordionFromHash();
  }

  window.addEventListener("hashchange", openAccordionFromHash);

  document.addEventListener("click", (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const rawHash = link.getAttribute("href").slice(1);
    if (!rawHash) return;

    const hash = decodeURIComponent(rawHash);
    const target = document.getElementById(hash);
    if (!target || !target.classList.contains("about")) return;

    event.preventDefault();

    if (window.history && history.replaceState) {
      history.replaceState(null, "", `#${hash}`);
    } else {
      window.location.hash = hash;
    }

    openAccordionFromHash();
  });
})();
